import { FaWhatsapp } from "react-icons/fa6";

const WHATSAPP_NUMBER = "15074325890";

export default function WhatsAppButton() {
  const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Hi Kavion! I'd love to learn more about scaling my Shopify store."
  )}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      className="fixed bottom-6 right-6 z-40 group"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-green-500/40 blur-xl group-hover:bg-green-500/60 transition" />
      <span className="relative flex items-center gap-2 bg-green-500 hover:bg-green-400 transition-all duration-300 hover:scale-105 text-white rounded-full pl-4 pr-5 py-3 shadow-2xl">
        <FaWhatsapp className="h-5 w-5" />
        <span className="hidden sm:inline text-sm font-semibold">Chat with us</span>
      </span>
    </a>
  );
}
